































import Vue, { PropType } from 'vue'
import VueI18n, { IVueI18n } from 'vue-i18n'
import Dialog from '~/components/Dialog.vue'
import Button from '~/components/Button.vue'
import { isMobile } from '~/modules/tools'
import { Services } from '~/services'

export default Vue.extend({
  name: 'ServiceUpgradeTips',
  components: {
    Dialog,
    Button
  },
  model: {
    prop: 'showing',
    event: 'close'
  },
  props: {
    showing: {
      type: Boolean,
      required: true
    },
    $tt: {
      type: Function as PropType<(key: string, params?: Record<string, string| number>) => string>,
      required: true
    },
    i18n: {
      type: Object as PropType<VueI18n & IVueI18n>,
      default: () => (({} as VueI18n & IVueI18n))
    },
    $services: {
      type: Object as PropType<Services>,
      default: () => (({} as Services))
    }
  },
  data () {
    return {
      twitterLink: 'https://twitter.com/DIDbased',
      title: '',
      message: ''
    }
  },
  computed: {
    isMobile
  },
  mounted () {
    this.getUpgradeNotice()
  },
  methods: {
    onClose () {
      this.$emit('close', false)
    },
    goTwitter () {
      if (this.isMobile) {
        window.location.href = this.twitterLink
      }
      else {
        window.open(this.twitterLink)
      }
    },
    async getUpgradeNotice () {
      try {
        const res = await this.$services.common.upgradeNotice()
        const locale = this.i18n.locale
        if (res && res[locale]) {
          const title = res[locale]?.service_upgrade_title
          const message = res[locale]?.service_upgrade_message
          if (title && message) {
            this.title = title
            this.message = message
          }
        }
      }
      catch (err) {
        console.log(err)
      }
    }
  }
})
